
(function () {
  'use strict';

  const THEME_VARIANT_UPDATE = 'variant:update';
  const THEME_CART_UPDATE = 'cart:update';

  function formatMoney(cents) {
    const fmt = window.Shopify?.money_format || '₪{{amount}}';
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function initBar(bar) {
    const sectionId = bar.dataset.sectionId;
    const productId = bar.dataset.productId;

    const variantsJson = bar.querySelector('[data-satc-variants]');
    const allVariants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

    const imageEl      = bar.querySelector('[data-satc-image]');
    const imageBtn     = bar.querySelector('[data-satc-image-btn]');
    const comparePriceEl = bar.querySelector('[data-satc-compare-price]');
    const currentPriceEl = bar.querySelector('[data-satc-current-price]');
    const variantSelect  = bar.querySelector('[data-satc-variant-select]');
    const addBtn         = bar.querySelector('[data-satc-btn]');

    const showComparePrice = addBtn?.dataset.showComparePrice === 'true';

    let currentVariantId = addBtn ? parseInt(addBtn.dataset.variantId, 10) : null;

    // ── Trigger element: the main ATC button ──────────────────────────
    function getMainATCButton() {
      return (
        document.querySelector(`[data-section-id="${sectionId}"] button[name="add"]`) ||
        document.querySelector(`[data-section-id="${sectionId}"] .add-to-cart-button`)
      );
    }

    function getMainVariantInput() {
      return document.querySelector(
        `product-form-component[data-section-id="${sectionId}"] input[name="id"]`
      );
    }

    function getMainVariantPicker() {
      return document.querySelector(`variant-picker[data-section-id="${sectionId}"]`);
    }

    // ── Visibility via IntersectionObserver ───────────────────────────
    let observer;
    let hasBeenVisible = false;

    function observeATC() {
      const mainATC = getMainATCButton();
      if (!mainATC) return;

      if (observer) observer.disconnect();

      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) hasBeenVisible = true;
          const show = !entry.isIntersecting && hasBeenVisible;
          bar.classList.toggle('sticky-atc--visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        },
        { threshold: 0 }
      );
      observer.observe(mainATC);
    }
    observeATC();

    // Re-observe after section HTML morphs (variant change may re-render)
    document.addEventListener(THEME_VARIANT_UPDATE, () => {
      requestAnimationFrame(observeATC);
    });

    // ── Image button: scroll to top of page ───────────────────────────
    if (imageBtn) {
      imageBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // ── Update bar state from variant object ─────────────────────────
    function updateFromVariant(variant) {
      if (!variant) return;
      currentVariantId = variant.id;

      if (currentPriceEl) {
        currentPriceEl.textContent = formatMoney(variant.price);
      }

      if (comparePriceEl) {
        if (showComparePrice && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.dataset.variantId = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (addBtn.dataset.addText || 'Add to cart')
          : (addBtn.dataset.soldText || 'Sold out');
      }

      if (variantSelect) {
        variantSelect.value = String(variant.id);
      }

      if (imageEl && variant.featured_media?.preview_image?.src) {
        imageEl.src = variant.featured_media.preview_image.src;
      }
    }

    // ── Listen for variant updates from main picker ───────────────────
    document.addEventListener(THEME_VARIANT_UPDATE, (e) => {
      const detail = e.detail;
      if (!detail) return;
      if (detail.data?.productId && detail.data.productId !== productId) return;
      if (detail.resource) updateFromVariant(detail.resource);
    });

    // ── Sticky variant select → sync main picker ──────────────────────
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const targetId = parseInt(variantSelect.value, 10);
        const targetVariant = allVariants.find((v) => v.id === targetId);
        if (!targetVariant) return;

        currentVariantId = targetId;

        const picker = getMainVariantPicker();
        if (picker) {
          syncMainPicker(picker, targetVariant);
        } else {
          const input = getMainVariantInput();
          if (input) {
            input.value = targetId;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    function syncMainPicker(picker, targetVariant) {
      // Try radio buttons first (buttons/swatches style)
      // Each option value may have data-variant-id for single-option products,
      // or we match by value per option name
      const options = ['option1', 'option2', 'option3'];
      const optionFieldsets = picker.querySelectorAll('fieldset.variant-option');
      const optionSelects   = picker.querySelectorAll('select.variant-option__select');

      if (optionFieldsets.length > 0) {
        optionFieldsets.forEach((fieldset, i) => {
          const value = targetVariant[options[i]];
          if (!value) return;
          const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
          if (radio && !radio.checked) {
            radio.click();
          }
        });
      } else if (optionSelects.length > 0) {
        optionSelects.forEach((select, i) => {
          const value = targetVariant[options[i]];
          if (!value) return;
          if (select.value !== value) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else {
        // Fallback: update hidden input directly
        const input = getMainVariantInput();
        if (input) {
          input.value = targetVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // ── Sticky ATC button → add to cart via AJAX ─────────────────────
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        if (addBtn.disabled) return;

        const variantId = currentVariantId || getMainVariantInput()?.value;
        if (!variantId) return;

        const originalText = addBtn.textContent.trim();
        addBtn.disabled = true;
        addBtn.textContent = '...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          });

          if (!res.ok) {
            const errData = await res.json().catch(() => ({}));
            throw new Error(errData.description || 'Cart error');
          }

          const cartData = await res.json();

          // Dispatch cart update so the theme's cart drawer reacts
          document.dispatchEvent(
            new CustomEvent(THEME_CART_UPDATE, {
              bubbles: true,
              detail: {
                resource: cartData,
                sourceId: `sticky-atc-${sectionId}`,
                data: {
                  source: 'sticky-atc',
                  variantId: String(variantId),
                },
              },
            })
          );

          // Open cart drawer
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
            else if (typeof cartDrawer.showDialog === 'function') cartDrawer.showDialog();
          }

          addBtn.textContent = '✓';
          setTimeout(() => {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1800);
        } catch {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[id^="sticky-atc-"]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
